import { ExternalLink } from '@atlassian/mpac-primitives';
import React from 'react';
import { PVPSection } from '../PricingTab.styles';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
const PaidViaPartnerPricing = props => {
  const {
    learnMoreUrl
  } = props;
  return /*#__PURE__*/_jsxs(PVPSection, {
    children: ["This app is sold by a third-party vendor.", ' ', learnMoreUrl && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(ExternalLink, {
        href: learnMoreUrl,
        children: "Contact the vendor"
      }), " to evaluate or purchase this app."]
    })]
  });
};
export default PaidViaPartnerPricing;